import { css } from '@emotion/react';

const setDurationStyles = {
    container: css({
        position: 'relative',
    }),
    columnWrapper: css({
        display: 'flex',
        flexWrap: 'wrap',
        marginTop: '25px',
        marginBottom: '16px',
    }),
    column: css({
        display: 'flex',
        flexGrow: 1,
        flexBasis: 0,
        flexDirection: 'column',
        justifyContent: 'center',
        gap: '20px',
    }),
    infoBlock: css({
        display: 'flex',
        flexBasis: 0,
        flexDirection: 'column',
        width: '100%',

        ['& button']: {
            width: '100%',
            maxWidth: 64,
            height: 44,
        },
    }),
    infoBlockTitle: css({
        fontWeight: 700,
        fontSize: '10px',
        lineHeight: '14px',
        color: '#000000',
        opacity: 0.5,
    }),
    infoBlockValue: css({
        display: 'flex',
        fontWeight: 700,
        fontSize: '16px',
        lineHeight: '18px',
        color: '#101010',
        alignItems: 'flex-end',
    }),
    infoBlockValueSymbol: css({
        fontWeight: 700,
        fontSize: '8px',
        lineHeight: '12px',
        color: '#101010',
        paddingLeft: '5px',
    }),
    durationBlock: css({
        width: '100%',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    }),
    durationValue: css({
        // position: 'absolute',
        // left: 0,
        // right: 0,
        // bottom: '50%',
        // transform: 'translateY(50%)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    }),
    inputDuration: css({
        background: 'transparent',
        textAlign: 'center',
        fontWeight: 500,
        fontSize: '16px',
        lineHeight: '100%',
        color: '#000000',
        width: '60px',
        border: 'none',
        ':focus': {
            outline: 'none !important',
            border: '2px solid black',
            borderRadius: '4px',
        },
        '::-webkit-outer-spin-button': {
            WebkitAppearance: 'none',
            margin: 0,
        },
        '::-webkit-inner-spin-button': {
            WebkitAppearance: 'none',
            margin: 0,
        },
        MozAppearance: 'textfield',
    }),
    durationValueLabel: css({
        fontWeight: 600,
        fontSize: '16px',
        color: '#000000',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        cursor: 'pointer',
        padding: '16px 0',
    }),
    durationEditSymbol: css({
        fontWeight: 700,
        fontSize: '10px',
        lineHeight: '10px',
        color: '#000000',
        textAlign: 'center',
        marginBottom: 2,
    }),
    actionWrapper: css({
        display: 'flex',
        justifyContent: 'center',
        gap: '20px',
        marginBottom: '12px',
        width: '100%',
        button: {
            width: '100%',
        },
    }),
    nextButton: css({
        width: '100%',
    }),
    blockingFeeBlock: css({
        marginBottom: '8px',
        display: 'flex',
        justifyContent: 'space-between',
    }),
    blockingFee: css({
        fontSize: 12,
        fontWeight: 500,
        color: '#000000',
    }),
    blockingFeeValue: css({
        fontSize: 12,
        fontWeight: 700,
        color: '#000000',
    }),
    durationUnits: css({
        fontSize: 10,
        fontWeight: 700,
        lineHeight: '16px',
        paddingLeft: 5,
    }),
};

export default setDurationStyles;
